import React from 'react';

import Text, { TextType, TextProps } from 'components/typography/text';

const P3: React.FC<React.PropsWithChildren<TextProps>> = (props) => (
  <Text type={TextType.P3} {...props}>
    {props.children}
  </Text>
);

export default P3;
